import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

const ROUTE_META = {
  '/': {
    title: 'jakobelektriker.dk',
    description:
      'Grundig og altid smilende elektriker, der arbejder med høj faglig erfaring. Kan selv grave løse grave opgaver og arbejde i op til 8 meters højde til DK\'s absolutte billigste priser. Altid frisk på at løse en opgave stor som lille, også uden for elfaget. Jeg sparer med andre selvstændige håndværkere',
  },
  '/el-arbejde': {
    title: 'El-arbejde - jakobelektriker.dk',
    description:
      'Jakob udfører alle former for almindeligt el-arbejde i private hjem og erhverv. 25 års erfaring og samarbejde med el-installatør ved autorisationskrævende opgaver.',
  },
  '/almindelige-el-opgaver': {
    title: 'El-arbejde - jakobelektriker.dk',
    description:
      'Jakob udfører alle former for almindeligt el-arbejde i private hjem og erhverv. 25 års erfaring og samarbejde med el-installatør ved autorisationskrævende opgaver.',
  },
  '/kabeltraek': {
    title: 'Kabeltræk - jakobelektriker.dk',
    description:
      'Specialist i lange kabeltræk med eget kabelaftrækkersystem på minilæsser. Trækker op til 3 kabler ad gangen og op til 2 km kabel om dagen samt kabelgravning og retablering på private arealer.',
  },
  '/lange-kabeltraek': {
    title: 'Kabeltræk - jakobelektriker.dk',
    description:
      'Specialist i lange kabeltræk med eget kabelaftrækkersystem på minilæsser. Trækker op til 3 kabler ad gangen og op til 2 km kabel om dagen samt kabelgravning og retablering på private arealer.',
  },
  '/liftarbejde': {
    title: 'Liftarbejde - jakobelektriker.dk',
    description:
      'Arbejde i højden med egen saxelift (8 m) og mobil Omme bomlift (10,5 m). Spar udlejerens dyre gebyrer. El-montage, tagrender og beskæring af høje grene.',
  },
  '/lift-arbejde': {
    title: 'Liftarbejde - jakobelektriker.dk',
    description:
      'Arbejde i højden med egen saxelift (8 m) og mobil Omme bomlift (10,5 m). Spar udlejerens dyre gebyrer. El-montage, tagrender og beskæring af høje grene.',
  },
  '/designerlamper': {
    title: 'Designerlamper - jakobelektriker.dk',
    description:
      'Professionel montering og tilbud på danske designerlamper inkl. montage. Rådgivning om korrekt placering og belysning i bolig eller erhverv.',
  },
  '/erhverv': {
    title: 'Erhverv - jakobelektriker.dk',
    description:
      'Pålidelig elektriker til erhverv, entreprenører og el-installatører. Stor erfaring med nybyg, store byggesager, kabelplan og højt specialiseret kabeltræk.',
  },
  '/om-jakob': {
    title: 'Om Jakob - jakobelektriker.dk',
    description:
      'Mød Jakob – erfaren elektriker med 25 års erfaring i el-faget. Enkeltmandsforretning med direkte kontakt, egne lifte, specialudstyr og fuld forsikring.',
  },
  '/kontakt': {
    title: 'Kontakt - jakobelektriker.dk',
    description:
      'Kontakt jakobelektriker.dk på telefon 22 32 99 79 eller jakobelektriker@hotmail.com. Adresse: Madegårdsvej 18, 5350 Rynkeby. CVR: 30867491.',
  },
  '/404': {
    title: 'Siden blev ikke fundet - jakobelektriker.dk',
    description: 'Fejlkode 404 - Siden blev ikke fundet på jakobelektriker.dk.',
  },
  '/403': {
    title: 'Adgang nægtet - jakobelektriker.dk',
    description: 'Fejlkode 403 - Adgang nægtet på jakobelektriker.dk.',
  },
}

export default function MetaManager() {
  const { pathname } = useLocation()

  useEffect(() => {
    const meta = ROUTE_META[pathname] || {
      title: 'jakobelektriker.dk',
      description:
        'Grundig og altid smilende elektriker med 25 års erfaring. El-arbejde, liftarbejde og kabeltræk.',
    }

    document.title = meta.title

    let metaTag = document.querySelector('meta[name="description"]')
    if (!metaTag) {
      metaTag = document.createElement('meta')
      metaTag.name = 'description'
      document.head.appendChild(metaTag)
    }
    metaTag.content = meta.description
  }, [pathname])

  return null
}
